<template>
  <div class="flow-master-body">
    <div>
      <div class="search-wrap">
        <el-button size="mini" type="primary" @click="editArticle()" style="margin-right: 5px;" icon="el-icon-plus">添加</el-button>
        <el-input size="mini" placeholder="请输入搜关键字" v-model="keyword" clearable style="width: 200px"></el-input>
        <el-select size="mini" v-model="where.is_h5" clearable placeholder="是否支持移动端">
          <el-option v-for="item in [{id:0,name:'不支持移动端'},{id:1,name:'支持移动端'},]" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
        <el-select size="mini" v-model="where.is_hide" clearable placeholder="是否隐藏">
          <el-option v-for="item in [{id:1,name:'隐藏'},{id:0,name:'显示'},]" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
        <el-button size="mini" type="primary" @click="search">搜索</el-button>
      </div>

      <div class="table-wrap">
        <el-table v-if="pageData" v-loading="loading" :data="pageData.list">
          <el-table-column prop="id" label="id" align="center" width="60"></el-table-column>
          <el-table-column prop="name" label="流程名称" align="center"></el-table-column>
          <el-table-column prop="is_h5" label="支持移动端" align="center" width="100">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.is_h5" type="success">支持</el-tag>
              <el-tag v-else type="info">不支持</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="weight" label="权重排序" align="center" width="100"></el-table-column>
          <!-- <el-table-column prop="type_id" label="流程类型" align="center" width="100"></el-table-column>
          <el-table-column prop="model_id" label="表数据模型" align="center" width="100"></el-table-column>
          <el-table-column prop="form_id" label="表单模型" align="center" width="100"></el-table-column>
          <el-table-column prop="sheet_id" label="流程模型" align="center" width="100"></el-table-column> -->
          <el-table-column prop="weight" label="权重排序" align="center" width="100"></el-table-column>
          <el-table-column prop="status" label="状态" align="center" width="100">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.status" type="success">已发布</el-tag>
              <el-tag v-else type="info">未发布</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="is_hide" label="隐藏" align="center" width="100">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.is_hide" type="info">隐藏</el-tag>
              <el-tag v-else type="success">显示</el-tag>
            </template>
          </el-table-column>

          <el-table-column prop="create_time" label="创建时间" align="center" width="100"></el-table-column>
          <el-table-column prop="update_time" label="修改时间" align="center" width="100"></el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <el-button type="primary" size="mini" icon="el-icon-edit" @click="editArticle(scope.row)">修改</el-button>
              <el-button type="danger" size="mini" icon="el-icon-delete" @click="deleteCmsChannel(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="pagination-wrap">
        <el-pagination background layout="prev, pager, next" :total="pageData.total*1" :page-size="pageData.pageSize*1" :current-page="pageData.page*1" @current-change="pageChange"></el-pagination>
      </div>
    </div>



    <!-- 修改窗口 -->
    <el-dialog title="编辑" :visible.sync="dialogVisible" :close-on-click-modal="false" width="600px">

      <div style="max-height: 500px;overflow-y: auto;">
        <el-form :model="form" ref="form" label-width="100px" size="mini" style="margin-right: 50px;">
          <el-form-item label="流程名称" prop="title">
            <el-input class="form-input" v-model="form.name" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="流程类型" prop="title">
            <el-input class="form-input" v-model="form.type_id" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="表数据模型" prop="title">
            <el-input class="form-input" v-model="form.model_id" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="表单模型" prop="title">
            <el-input class="form-input" v-model="form.form_id" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="流程模型" prop="title">
            <el-input class="form-input" v-model="form.sheet_id" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="权重排序" prop="title">
            <el-input class="form-input" v-model="form.weight" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="状态" prop="title">
            <el-radio v-model="form.status" label="1">显示</el-radio>
            <el-radio v-model="form.status" label="0">隐藏</el-radio>
          </el-form-item>
        </el-form>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm('form')" >确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>

import Http from "./common/Http";
import UploadFilesSysc from "./components/UploadFilesSysc";
import UploadFileSysc from "./components/UploadFileSysc";

export default {
  name:"FlowMaster",
  components: {UploadFileSysc, UploadFilesSysc},
  data () {
    return {
      host_url:"",
      keyword: '',
      loading: false,
      contract_area_id:'',
      pageData:{
        list:[],
        total:0,
        pageSize:20,
        page:1
      },
      dialogVisible:false,
      form:{
        name:"",
        type_id:"",
        model_id:"",
        form_id:"",
        sheet_id:"",
        weight:"",
        status:"",
      },
      uploadUrl:"",
      month_money_list:[],
      project_list:[],
      error_list:[],
      error_show_status:false,
      where:{
        is_h5:"",
        is_hide:0
      }
    }
  },
  created() {
    this.host_url=Http.getBaseURL();
    this.uploadUrl=this.host_url+"flow/UserRole/uploadFile";
    // this.getList()
  },
  activated() {
    this.getList()
  },
  watch: {
    dialogVisible(val) {
      if(val == false) {
        // this.fileList = []
      }
    },

  },
  methods: {
    getFormData(data) {
      return Object.assign({
        id:'',
        name:"",
        type_id:"",
        model_id:"",
        form_id:"",
        sheet_id:"",
        weight:"",
        status:"",
      }, data)
    },
    search() {
      this.pageData.page = 1
      this.getList()
    },
    getList() {
      var that=this;
      that.loading=true;
      let where=ERP.reJson(that.where);
      this.keyword&&(where.name=this.keyword);
      Http.get("flow/FlowMaster/getList",{
        where:JSON.stringify(where),
        page: this.pageData.page,
        page_size: this.pageData.pageSize
      },res=>{
        if(res.code) {
          that.pageData=res.data
        }
        that.loading=false;
      })
    },
    pageChange(i) {
      this.pageData.page = i
      this.getList()
    },
    editArticle(item) {
      this.$router.push({path: '/flow/FlowCreate', query: {id: item ? item.id : 0}})
    },

    submitForm(formName) {
      var that=this;
      that.$refs[formName].validate((valid) => {
        if (valid) {
          that.formLoading = true
          let data = Object.assign({}, this.form)
          console.log(data)
          Http.post("flow/FlowMaster/save",data,res => {
            that.$message({type: res.code === 1 ? 'success': 'error', message: res.msg})
            if(res.code) {
              that.dialogVisible = false
              that.getList()
            }
            that.formLoading = false
          })
        } else {
          return false;
        }
      });
    },

    setFrom(data){
      var that=this;
      Http.post("flow/FlowMaster/save",data,res => {
        that.$message({type: res.code === 1 ? 'success': 'error', message: res.msg})
        if(res.code) {
          that.getList()
        }
      })
    },
    onAreaChange({data,pathData,ids}){
      this.form.province_city=data.mergename;
      this.form.province_city_ids=ids.join(',')
    },
    onContractAreaChange({data,pathData,ids}){
      let adrr=""
      pathData.map((ret,index)=>{
        adrr+=ret.name+(pathData[index+1]?' -> ':'')
      })
      this.form.contract_area=adrr;
      this.form.contract_area_ids=ids.join(',')
    },
    deleteCmsChannel(item){
      var that=this;
      this.$confirm(`此操作将删除流程 [ ${item.name} ] , 是否继续?`, '提示', {type: 'warning'}).then(() => {
        Http.post("flow/FlowMaster/deleteFlowMaster", {id:item.id},res => {
          that.$message({type: res.code === 1 ? 'success': 'error', message: res.msg})
          if(res.code) {
            that.getList()
          }
        })
      })
    },
    nodeClick1(n){
      this.contract_area_id=n.id;
      this.pageData={
        list:[],
        total:0,
        pageSize:20,
        page:1
      }
      this.getList()
    }
  }
}
</script>
<style lang="scss" scoped>

@import './common.scss';

.form-input {
  width: 300px;
}
.table-wrap{
  width: calc( 100vw - 120px - 200px );
  overflow-x: scroll;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Flow/FlowMaster.vue